import api, { isSessionExpired, reportApiError } from '../api'
import qs from 'qs'

const STORAGE_NAME = `carpool_${process.env.VUE_APP_WEB}`;

export default {
  namespace: true,
  state: {
    books: [],
    schedules: [],
    loading: false,
    loadingSchedule: false
  },
  getters: {
    books(state) {
      return state.books
    },
    schedules(state) {
      return state.schedules
    },
    loadingSchedule(state) {
      return state.loadingSchedule
    }
  },
  mutations: {
    CLEAR_BOOKS(state) {
      state.books.splice(0)
    },
    ADD_BOOK_TO_LIST(state, book) {
      state.books.push(book)
    },
    CLEAR_SCHEDULES(state) {
      state.schedules.splice(0)
    },
    ADD_SCHEDULE_TO_LIST(state, schedule) {
      state.schedules.push(schedule)
    },
    SET_LOADING_SCHEDULE(state, loadingSchedule) {
      state.loadingSchedule = loadingSchedule
    }
  },
  actions: {
    LOAD_BOOKS({ commit }, payload) {
      const query = qs.stringify(payload)
      const url   = `${process.env.VUE_APP_API_URL}/get_booking_information`
      return api.post(url, query)
        .then((response) => {
          const books = response.data.data
          if (!Array.isArray(books)) return
          books.forEach((book) => {
            commit('ADD_BOOK_TO_LIST', book)
          })
        })
        .catch((error) => {
          // The interceptor now reports the expiry as a 401, so this no longer
          // depends on matching the exact wording of the server's message.
          if (isSessionExpired(error)) {
            try {
              localStorage.removeItem(`USER_DATA_${STORAGE_NAME}`)
            } catch (e) {}
            window.location.reload()
            return new Promise(() => {})
          }
          reportApiError(error, 'get_booking_information')
        })
    },
    LOAD_SCHEDULES({ commit }, payload) {
      const query = qs.stringify(payload)
      const url   = `${process.env.VUE_APP_API_URL}/get_schedules`
      commit('SET_LOADING_SCHEDULE', true);
      return api.post(url, query)
        .then(response => {
          const schedules = response.data.data
          if (Array.isArray(schedules)) {
            schedules.forEach((schedule) => {
              commit('ADD_SCHEDULE_TO_LIST', schedule)
            })
          }
          commit('SET_LOADING_SCHEDULE', false);
        })
        .catch((error) => {
          reportApiError(error, 'get_schedules')
          commit('SET_LOADING_SCHEDULE', false);
        })
    }
  }
}
